import { FunctionComponent } from 'react';

import { DataTableVariants } from '../../constants';
import { HeaderCell } from './HeaderCell';
import { HeaderCellProps } from './HeaderCellProps';

export const HeaderCellSecondary: FunctionComponent<HeaderCellProps> = (props) => <HeaderCell {...props} variant={DataTableVariants.SECONDARY} />;

HeaderCellSecondary.displayName = 'HeaderCellSecondary';
